import React from 'react';
import DashboardGrid from '../../components/Dashboard/DashboardGrid';

const StorefrontDashboardPage: React.FC = () => {
    return (
        <div className='main-content'>
            <h1>Storefront</h1>
            <DashboardGrid resource="storefront" />
        </div>
    );
};

export default StorefrontDashboardPage;
